import React from "react";
import { Tabs } from "antd";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import BankTransactionLog from "./bankTransactionLog";
import FaultyBankTransactionLog from "./faultyBankTransactionLog";

const BankTransactionLogPage = () => {
  const { account } = useParams();
  const navigate = useNavigate();
  const location = useLocation();

  const isFaulty = location.pathname.startsWith("/faultyBankTransactionLog/");
  const activeKey = isFaulty ? "faulty" : "all";

  const handleTabChange = (key) => {
    if (key === "faulty") {
      navigate(`/faultyBankTransactionLog/${account}`);
    } else {
      navigate(`/bankTransactionLog/${account}`);
    }
  };

  const tabItems = [
    {
      key: "all",
      label: "Дансны хуулга",
      children: <BankTransactionLog />,
    },
    {
      key: "faulty",
      label: "Алдаатай гүйлгээ",
      children: <FaultyBankTransactionLog />,
    },
  ];

  return (
    <div className="mt-1">
      <Tabs
        activeKey={activeKey}
        onChange={handleTabChange}
        items={tabItems}
      />
    </div>
  );
};

export default BankTransactionLogPage;
